// extracted by mini-css-extract-plugin
export default {"container":"AboutProgram_container_nbKIH","img":"AboutProgram_img_XHs1h","text":"AboutProgram_text_YIkQN"};